import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { HotelTransferSearchViewModel } from '../models/HotelTransferSearchViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class TransfersService {
  /**
   * Search (Hotel)
   * Search for hotel transfers
   * @returns HotelTransferSearchViewModel Success
   * @throws ApiError
   */
  public static async searchHotelTransfer(
    {
      hotelId,
      regionId,
      startPointId,
      beginDate,
      endDate,
    }: {
      hotelId?: number;
      regionId?: number;
      startPointId?: number;
      beginDate?: string;
      endDate?: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<Array<HotelTransferSearchViewModel>> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<Array<HotelTransferSearchViewModel>>({
      method: 'GET',
      url: `/transfers/hotel/search`,
      query: {
        ...(hotelId ? { hotelId: hotelId } : {}),
        ...(regionId ? { regionId: regionId } : {}),
        ...(startPointId ? { startPointId: startPointId } : {}),
        ...(beginDate ? { beginDate: beginDate } : {}),
        ...(endDate ? { endDate: endDate } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
